import { render, staticRenderFns } from "./AddReason.vue?vue&type=template&id=2c85f67c&scoped=true"
import script from "./AddReason.vue?vue&type=script&lang=js"
export * from "./AddReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85f67c",
  null
  
)

export default component.exports